import { call, put, takeLatest, cancelled } from "redux-saga/effects";
import { fetchCeaProfileDownloadFiles } from "../../service/fetchCeaProfileDownloadFiles";
import {
  downloadCeaProfileFilesSuccess,
  downloadCeaProfileFilesFailure,
} from "../reducers/drmCeaProfileDownloadSlice";

export function* workerDownloadCeaProfileFiles({ payload }) {
  const controller = new AbortController();
  try {
    const response = yield call(fetchCeaProfileDownloadFiles, [payload, controller]);
    const message = response?.data?.message;
    const data = response?.data?.details?.data;
    yield put(downloadCeaProfileFilesSuccess({ message, data }));
  } catch (error) {
    const message = error?.response?.data?.message || error?.message;
    yield put(downloadCeaProfileFilesFailure(message));
  } finally {
    if (yield cancelled()) {
      controller.abort();
    }
  }
}

function* drmCeaProfileDownloadSaga() {
  yield takeLatest("drmCeaProfileDownload/downloadCeaProfileFilesStart", workerDownloadCeaProfileFiles);
}

export default drmCeaProfileDownloadSaga;
